import React from 'react';

/**
 * Reusable Image Row Component
 * Displays a single image in a list with checkbox, thumbnail, and metadata
 * 
 * @param {Object} image - Image object with id, imageName, shopifyImageUrl, etc.
 * @param {boolean} isSelected - Whether the image is selected
 * @param {boolean} selectAllStore - Whether store-wide selection is active
 * @param {Function} onToggle - Handler when image is toggled
 * @param {Function} onCompare - Optional handler for compare action
 */
function ImageRow({ image, isSelected, selectAllStore, onToggle, onCompare }) {
  const previewSrc = image.shopifyImageUrl || image.s3OriginalImageUrl;

  // TASK 6: Image row is clickable to open compare modal (eye icon removed)
  // Checkbox click must NOT open modal - handled via stopPropagation
  return (
    <div
      className="image-row-item"
      onClick={() => {
        if (onCompare && image.s3OriginalImageUrl && image.shopifyImageUrl) {
          onCompare(image);
        }
      }}
    >
      {/* Thumbnail */}
      {previewSrc ? (
        <s-box border="base" borderRadius="base" overflow="hidden" inlineSize="40px" blockSize="40px" style={{ flexShrink: 0 }}>
          <img src={previewSrc} alt={image.imageName} style={{ width: '40px', height: '40px', objectFit: 'cover', display: 'block' }} />
        </s-box>
      ) : (
        <s-box inlineSize="40px" blockSize="40px" borderRadius="base" className="product-thumbnail-container" style={{ flexShrink: 0 }}>
          <s-text tone="subdued">🖼️</s-text>
        </s-box>
      )}

      {/* Info */}
      <s-stack gap="small-100" style={{ flex: 1, minWidth: 0 }}>
        <s-text emphasis="strong">{image.imageName}</s-text>
        <s-stack gap="small-100" direction="inline" alignItems="center" style={{ flexWrap: 'wrap' }}>
          {image.optimizationType && (
            <s-badge tone="info">
              {image.optimizationType.title}
            </s-badge>
          )}
          {!image.optimizationType && image.optimizedType && (
            <s-badge tone="info">
              {image.optimizedType.charAt(0).toUpperCase() + image.optimizedType.slice(1)}
            </s-badge>
          )}
          <s-badge>Original: {image.originalSize ? parseFloat(image.originalSize).toFixed(2) : '–'} KB</s-badge>
          <s-badge tone="success">Optimized: {image.optimizedSize ? parseFloat(image.optimizedSize).toFixed(2) : '–'} KB</s-badge>
          <s-badge tone="info">Saved: {image.savingsPercent ? parseFloat(image.savingsPercent).toFixed(1) : '–'}%</s-badge>
          {image.optimizedAt && (
            <s-text tone="subdued" size="small">
              {new Date(image.optimizedAt).toLocaleDateString()}
            </s-text>
          )}
        </s-stack>
      </s-stack>
    </div>
  );
}

export default ImageRow;

